module.exports = __webpack_public_path__ + "static/media/27import-58.404469fe.xlsx";